export const TableFormCellProp = Object.freeze({
    CellType: 'cellType',
    ColumnName: 'columnName',
    PositionNumber: 'positionNumber',
    FieldProps: 'fieldProps',
    Buttons: 'buttons',
    Text: 'text',
    Flag: 'flag',
    DownloadFileAction: 'downloadFileAction',
    MultipleDownloadLinks: 'multipleDownloadLinks',
});